export const Company = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 4C4 3.44772 4.44772 3 5 3H21C21.5523 3 22 3.44772 22 4V29H4V4Z" stroke="currentColor" stroke-width="2"/>
<path d="M21 13H29C29.5523 13 30 13.4477 30 14V29H21" stroke="currentColor" stroke-width="2"/>
<path d="M16 8V12" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M10 8V12" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M16 14V18" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M16 20V24" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M10 14V18" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M10 20V24" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
